import React from 'react'

export default class StripePaymentMethod extends React.Component {
    handleSelect(method) {
        this.props.onSelect(method);
    }

    handleDelete(method, event) {
        event.stopPropagation();
        this.props.onDelete(method);
    }

    renderCardBrandIcon(brand) {
        let iconName;

        switch (brand) {
            case "americanexpress":
                iconName = "amex";
                break;
            case "visa":
                iconName = "visa";
                break;
            case "mastercard":
                iconName = "mastercard";
                break;
            default:
                iconName = "credit-card";
                break;
        }

        return (<i style={ {lineHeight: '21px'}} className={`fab fa-2x fa-cc-${iconName}`}/>);
    }

    renderRemoveCardLink() {
        if (this.props.canBeDeleted) {
            return <a className="primary-2-style" onClick={this.handleDelete.bind(this, this.props.method)}>
                <i className="fal fa-trash"/>
            </a>
        } else {
            return <span/>;
        }
    }

    render() {
        const { method } = this.props;
        const { card, metadata } = method;
        const {brand, last4} = card;
        const label = metadata && metadata["label"];

        return (
            <div className={this.props.isSelected ? 'item default' : 'item'}
                 onClick={this.handleSelect.bind(this, method)}>
                <div className="row">
                    <div className="col-xs-1" >
                        <input type="radio" checked={this.props.isSelected} readOnly={true} />
                    </div>
                    <div className="col-xs-2 col-md-1">
                        {this.renderCardBrandIcon(brand)}
                    </div>
                    <div className="col-xs-7">
                        {label && <div className="card--label">{label}</div> }
                        <div className="card--number">**** **** **** {last4}</div>
                    </div>
                    <div className="col-xs-1">
                        {this.renderRemoveCardLink()}
                    </div>
                </div>
            </div>
        );
    }
}
